import { Box, Button, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogContentTitle, DialogTitle } from '~/components/dialogs/components';
import { DialogActions, DialogContent } from '~/components/dialogs/lib/styles';

export interface ExportDownloadDialogProps {
  close: () => void;
  downloadUrl: string | null;
}

export const ExportDownloadDialog = ({ close, downloadUrl }: ExportDownloadDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog fullWidth maxWidth="md" onClose={close} open={Boolean(downloadUrl)}>
      <DialogTitle onClose={close}>
        {t('pages.data_sources.export_download_dialog.title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentTitle>
          {t('pages.data_sources.export_download_dialog.success_message')}
        </DialogContentTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="subtitle1">
            {t('pages.data_sources.export_download_dialog.download_prompt')}
          </Typography>
          {downloadUrl && (
            <Link sx={{ fontSize: '1.2em' }} target="_blank" rel="noreferrer" href={downloadUrl}>
              {t('common.buttons.download')}
            </Link>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={close} variant="outlined">
          {t('common.dialogs.close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
